import styled, { css } from 'styled-components';
import { propStyling } from '../../shared/propStyling';
import { textStyles } from '../../shared/textStyles';
import { tombac } from '../../shared/tombac';
export const Label = styled.label.withConfig({
  displayName: "Label"
})(["all:initial;", " ", " ", " ", ""], _ref => {
  let {
    required
  } = _ref;
  return required ? css(["&::after{color:", ";content:'*';display:inline;}"], tombac.color('danger')) : undefined;
}, tombac.typography.label, textStyles, propStyling);
//# sourceMappingURL=Label.js.map